export const formatVideoLength = (videoLength: string): string => {
  const parts = videoLength.split(':')

  if (parts.length === 0) {
    console.warn('formatVideoLength was provided with incorrect value:', videoLength)
  }

  // we should count position in reverse should backend return a shorter string (without hours)
  const hours = Number(parts[parts.length - 3])

  if (hours > 0) {
    return `${hours} hour${hours === 1 ? '' : 's'}`
  }

  const mins = Number(parts[parts.length - 2])

  if (mins > 0) {
    return `${mins} min${mins === 1 ? '' : 's'}`
  }

  const secs = Number(parts[parts.length - 1])

  return `${secs} sec${secs === 1 ? '' : 's'}`
}
